import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InDayScrollContainer, combineHandlers } from 'owa-calendar-surface-core';
import {
    useAllDayCollapseHooks,
    useScrollToWorkingHoursHooks,
    CalendarSurfaceStore,
} from 'owa-calendar-surface-dategrid';
import { useWeekViewResizeHooks } from 'owa-calendar-surface';

export interface InDayAdditionalPropsType {
    surfaceStore: CalendarSurfaceStore;
}

export default observer(function InDayComponent({
    className,
    children,
    handlers,
    additionalProps,
}: {
    className?: string;
    children?: React.ReactNode;
    handlers?: React.DOMAttributes<HTMLElement>;
    additionalProps: InDayAdditionalPropsType;
}) {
    const { surfaceStore } = additionalProps;

    const ref = React.useRef<HTMLElement>();
    const behaviorHook = useAllDayCollapseHooks({
        store: surfaceStore,
        collapseOnFocus: true,
    })(ref);

    useScrollToWorkingHoursHooks({
        store: surfaceStore,
        shouldScrollToWorkingHours: true,
    })(ref);

    useWeekViewResizeHooks({
        store: surfaceStore,
    })(ref);

    const handlersToAttach = combineHandlers(behaviorHook.handlers, handlers);

    return (
        <InDayScrollContainer ref={ref} className={className} handlers={handlersToAttach}>
            {children}
        </InDayScrollContainer>
    );
});
